// WS #2219705 (PACK, 10-15): "some people don't have email but they have text… some clients are old and
// don't have an email". PACK reps were typing made-up addresses on real domains, and the signed agreement
// sent to that address carries full card numbers. With CONTACT_EMAIL_OPTIONAL on, a client of an office
// offered the card split (flat fee only AND collects its own payments: PACK) may be enrolled with no email.
// The server decides again on create; this only stops the screen from blocking.
import { validateEmail } from "../../../helpers/validationEmail"

const isCardSplitOfficeSettings = (settings) => settings?.flatFeeOnly === true && settings?.affiliateBilled === true

// New client: the rep's active office settings. Existing client: the lead GET (feeShape.cardSplit).
export const emailOptionalFor = ({ flagOn, createOfficeSettings, contactGroupConfig } = {}) => flagOn === true
  && (contactGroupConfig?.feeShape?.cardSplit === true || isCardSplitOfficeSettings(createOfficeSettings))

// An empty email blocks Save only where it is required; a typed one must always be valid.
export const emailBlocksSave = ({ email, optional }) => (optional && !email ? false : !validateEmail(email))
